/* eslint-disable react/prop-types */
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Spinner = function Spinner(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'spinner' : _ref$className;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    viewBox: "25 25 50 50",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Loading, Rotating Circle Icon"
    }), /*#__PURE__*/_jsx("circle", {
      "aria-hidden": "true",
      className: "".concat(className, "__path"),
      cx: "50",
      cy: "50",
      r: "20",
      fill: "none",
      strokeWidth: "1",
      strokeMiterlimit: "10"
    })]
  });
};

export default Spinner;